var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ isMobile: _vm.isMobile },attrs:{"id":"app"}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/App.vue?vue&type=template&id=495df612
// module id = null
// module chunks = 